import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import BasicTabView from './BasicTabView'
import TimeLineTabView from './TimeLineTabView'

const Tabs = ({ theme, title, description, tabItem, footer }) => {
  const [activeTab, setActiveTab] = useState(0)
  const [activeAccordionTab, setActiveAccordionTab] = useState(-1)
  const [isDropdownActive, setIsDropdownActive] = useState(false)
  const [isAccordion, setIsAccordion] = useState(false)

  const handleResize = () => {
    setIsAccordion(window.innerWidth <= 1000)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // Set isAccordion initially on component mount
  useEffect(() => {
    handleResize()
  }, [])

  const handleTabChange = (index) => {
    if (theme === 'basic') {
      if (isAccordion) {
        setActiveAccordionTab((prevIndex) => (prevIndex === index ? -1 : index))
      } else {
        setActiveTab(index)
      }
    } else {
      setActiveTab(index)
    }
  }

  return (
    <>
      <BasicTabView
        tabItem={tabItem}
        activeTab={isAccordion ? activeAccordionTab : activeTab}
        title={title}
        description={description}
        handleClick={handleTabChange}
        isAccordion={isAccordion}
        theme={theme}
      />

      <TimeLineTabView
        theme={theme}
        tabItem={tabItem}
        activeTab={activeTab}
        handleTabClick={handleTabChange}
        isDropdownActive={isDropdownActive}
        setIsDropdownActive={setIsDropdownActive}
        setActiveTab={setActiveTab}
        footer={footer}
        title={title}
        description={description}
      />
    </>
  )
}

export default Tabs

export const query = graphql`
  fragment TabsData on STRAPI__COMPONENT_COMPONENT_TABS {
    theme
    tabItem {
      title
      sidebar
      description {
        format
        level
        type
        children {
          text
          type
          url
          bold
          children {
            text
            type
            url
            children {
              text
              type
            }
          }
        }
      }
    }
    title {
      copy
      header
    }
    description {
      children {
        text
        type
      }
      type
    }
    footer {
      type
      children {
        text
        type
        url
        children {
          text
          type
        }
      }
    }
  }
`
